import { SyntaxNode } from "@lezer/common";

 /**
 * a wrapper class around the SyntaxNode object, but 
 * whose ranges/positions are all relative to a given 
 * anchor position.
 * 
 * Used to make syntax nodes reusable even when the source text is edited and the syntax node's position changes.
 * It is also anchored in the sense that you can only explore the descendants of the node which is passed into the constructor.
 * That node becomes the root, which you can't explore beyond.
 */
export class SourceNode {
    private root: SyntaxNode; // TODO: for restricting client from visiting parents or siblings beyond the root node of an SourceNode
    constructor(
        private node: SyntaxNode, 
        private anchorPos: number,
    ) {
        this.root = node;
    }

    get type() { return this.node.type }
    get name() { return this.node.name }
    get from() { return this.node.from - this.anchorPos }
    get to() { return this.node.to - this.anchorPos }
    get fixed() { return { from: this.node.from, to: this.node.to } }

    getChild(type: string | number) {
        const child = this.node.getChild(type);
        return child ? this.anchor(child) : null
    }
    getChildren(type: string | number) {
        return this.node.getChildren(type).map((node) => this.anchor(node));
    }
    createOffsetCopy(offset: number) {
        const copy = this.anchor(this.node)
        copy.anchorPos += offset;
        return copy;
    }

    // TODO: implement traversal methods like firstChild, nextSibling, e.t.c. make sure traversal is rooted at the `root` node

    private anchor(node:SyntaxNode) {
        const syntaxNode = new SourceNode(node, this.anchorPos);
        syntaxNode.root = this.root;
        return syntaxNode;
    }
}
